import { Common, SimpleGenEq } from '../genHelper';

// Math_Addition_Subtraction
export class Math_Addition_Subtraction__To1000__3Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusMinus(3, 1000), 'Math_Addition_Subtraction__To1000__3Numbers');
  }
}
export class Math_Addition_Subtraction__To1000__4Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusMinus(4, 1000), 'Math_Addition_Subtraction__To1000__4Numbers');
  }
}
export class Math_Addition_Subtraction__To1000__5Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusMinus(5, 1000), 'Math_Addition_Subtraction__To1000__5Numbers');
  }
}

export class Math_Addition_Subtraction__To100__3Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusMinus(3, 100), 'Math_Addition_Subtraction__To100__3Numbers');
  }
}
export class Math_Addition_Subtraction__To100__4Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusMinus(4, 100), 'Math_Addition_Subtraction__To100__4Numbers');
  }
}
export class Math_Addition_Subtraction__To100__5Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusMinus(5, 100), 'Math_Addition_Subtraction__To100__5Numbers');
  }
}

export class Math_Addition_Subtraction__To20__3Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusMinus(3, 20), 'Math_Addition_Subtraction__To20__3Numbers');
  }
}
export class Math_Addition_Subtraction__To20__4Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusMinus(4, 20), 'Math_Addition_Subtraction__To20__4Numbers');
  }
}
export class Math_Addition_Subtraction__To20__5Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusMinus(5, 20), 'Math_Addition_Subtraction__To20__5Numbers');
  }
}
